module.exports = __webpack_public_path__ + "img/jg.3a950cc1.png";